import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PRICING_PLANS_AVAILABLE } from 'src/config/global';
import ModalSystem, { SUBSCRIPTION_MODAL_KEY } from 'src/systems/ModalSystem';
import SubscriptionPlanSelectionModal from '../SubscriptionPlanSelectionModal/SubscriptionPlanSelectionModal';

const GlobalSubscriptionPlanSelectionModal = () => {
	const dispatch = useDispatch();
	const modalSystem = new ModalSystem( dispatch );
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error
	const modals = useSelector( state => state.modals );

	const showModal = PRICING_PLANS_AVAILABLE && modals.get( SUBSCRIPTION_MODAL_KEY );

	const hideModal = useCallback(
		() => modalSystem.hideModal( { modalKey: SUBSCRIPTION_MODAL_KEY } ),
		[ modalSystem ]
	);

	if ( !showModal ) { return null; }

	return (
		<SubscriptionPlanSelectionModal stackOrder={1} onClose={hideModal} />
	);
};

export default GlobalSubscriptionPlanSelectionModal;
